import * as React from 'react';
import { observer } from 'mobx-react-lite';

export const WIDE_CONTENT_HOST_CLASS_NAME = 'wide-content-host';

export default function wideContentHost<T>(InnerComponent: React.ComponentClass<T>): any {
    return observer(function wideContentHost(props: T) {
        return (
            <div className={WIDE_CONTENT_HOST_CLASS_NAME}>
                <InnerComponent {...props} />
            </div>
        );
    });
}
